






import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GLoading from '@/components/GLoading.vue';

@Component({
  name: 'GSurveyChart',
  components: { GLoading },
})
export default class GSurveyChart extends mixins(GPageBase) {
  @Prop() surveyType: number;

  mounted() {}

  get options(): any {
    // typeでフィルター
    return statisticsModule.echartService.options.find((op: any) => op.type === String(this.surveyType));
  }

  get loading(): boolean {
    return statisticsModule.loading;
  }
}
